//API
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const SHOW_WARNING = 'show_warning';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const TOGGLE_APP_DRAWER = 'toggle_app_drawer';
export const UPDATING_CONTENT = 'updating_content';
export const SET_MENU_HEADER = 'set_menu_header';


//APP SETTING
export const TOGGLE_NAV_COLLAPSED = 'toggle_nav_collapsed';
export const SET_INITIAL_PATH = 'set_initial_path';

//AUTH0
export const UPDATE_AUTH_USER = 'update_auth_user';
export const SET_AUTH_TOKEN = 'set_auth_token';
export const SIGNOUT_AUTH_SUCCESS = 'signout_auth_success';

//ANALYTICS-DASHBOARD
export const GET_ANALYTICS_DATA = 'get_analytics_data';

//ECOMMERCE-DASHBOARD
export const GET_ECOMMERCE_DATA = 'get_ecommerce_data';

//ACADEMY-DASHBOARD
export const GET_ACADEMY_DATA = 'get_academy_data';

//CRM-DASHBOARD
export const GET_CRM_DATA = 'get_crm_data';

//CRYPTO-DASHBOARD
export const GET_CRYPTO_DATA = 'get_crypto_data';

//HEATH_ CARE-DASHBOARD
export const GET_HC_DATA = 'get_hc_data';

//METRICS-DASHBOARD
export const GET_METRICS_DATA = 'get_metrics_data';

//WIDGETS_DASHBOARD
export const GET_WIDGETS_DATA = 'get_widgets_data';

//KEPEGAWAIAN DASHBOARD
export const GET_KESEJAHTERAAN_PEGAWAI = 'get_kesejahteraan_pegawai';
export const GET_PERENCANAAN_PEGAWAI = 'get_perencanaan_pegawai';

//PRODUKSI BUDIDAYA DASHBOARD
export const GET_TEKNOLOGI_TERBARU = 'get_teknologi_terbaru';
export const GET_EMPLOYEE = 'get_employee';
export const GET_EMPLOYEE_V2 = 'get_employee_v2';
export const GET_DETAIL_EMPLOYEE = 'get_detail_employee';
export const GET_UNIT_KERJA = 'get_unit_kerja';

//MAIL-APP
export const GET_MAIL_LIST = 'get_mail_list';
export const GET_FOLDER_LIST = 'get_folder_list';
export const GET_LABEL_LIST = 'get_label_list';
export const TOGGLE_MAIL_DRAWER = 'toggle_mail_drawer';
export const COMPOSE_MAIL = 'compose_mail';
export const GET_MAIL_DETAIL = 'get_mail_detail';
export const UPDATE_MAIL_FOLDER = 'update_mail_folders';
export const UPDATE_MAIL_LABEL = 'update_mail_label';
export const UPDATE_STARRED_STATUS = 'update_starred_status';
export const UPDATED_MAIL_DETAIL = 'updated_mail_detail';
export const CHANGE_READ_STATUS = 'change_read_status';
export const GET_CONNECTION_LIST = 'get_connection_list';
export const NULLIFY_MAIL = 'nullify_mail';


//AKSI PERUBAHAN
export const GET_AKSI_PERUBAHAN = 'get_aksi_perubahan'
export const GET_FILTER_AKSI_PERUBAHAN = 'get_filter_aksi_perubahan'
export const RESET_FILTER_AKSI_PERUBAHAN = 'reset_filter_akis_perubahan'
export const POST_AKSI_PERUBAHAN = 'post_aksi_perubahan'
export const GET_DETAIL_AKSI_PERUBAHAN = 'get_detail_aksi_perubahan'
export const GET_DASHBOARD_AKSI_PERUBAHAN = 'get_dashboard_aksi_perubahan'

export const DELETE_AKSI_PERUBAHAN = 'delete_aksi_perubahan'
export const IMPORT_AKSI_PERUBAHAN = 'import_aksi_perubahan'

export const RESET_AKSI_PERUBAHAN = 'reset_aksi_perubahan'


//TODO-APP
export const GET_TASK_LIST = 'get_task_list';
export const CREATE_NEW_TASK = 'create_new_task';
export const TOGGLE_TODO_DRAWER = 'toggle_todo_drawer';
export const GET_TODO_FOLDER_LIST = 'GET_TODO_FOLDER_LIST';
export const GET_TODO_LABEL_LIST = 'GET_TODO_LABEL_LIST';
export const GET_TODO_STATUS_LIST = 'GET_TODO_STATUS_LIST';
export const GET_TODO_PRIORITY_LIST = 'GET_TODO_PRIORITY_LIST';
export const UPDATE_TASK_FOLDER = 'UPDATE_TASK_FOLDER';
export const UPDATE_TASK_LABEL = 'UPDATE_TASK_LABEL';
export const UPDATE_TASK_STARRED_STATUS = 'UPDATE_TASK_STARRED_STATUS';
export const GET_TASK_DETAIL = 'GET_TASK_DETAIL';
export const UPDATE_TASK_DETAIL = 'UPDATE_TASK_DETAIL';
export const GET_TODO_STAFF_LIST = 'GET_TODO_STAFF_LIST';

//CONTACT_APP
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST';
export const GET_CONTACT_FOLDER_LIST = 'GET_CONTACT_FOLDER_LIST';
export const GET_CONTACT_LABEL_LIST = 'GET_CONTACT_LABEL_LIST';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const UPDATE_CONTACT_LABEL = 'UPDATE_CONTACT_LABEL';
export const UPDATE_CONTACT_STARRED_STATUS = 'UPDATE_CONTACT_STARRED_STATUS';
export const GET_CONTACT_DETAIL = 'GET_CONTACT_DETAIL';
export const TOGGLE_CONTACT_DRAWER = 'TOGGLE_CONTACT_DRAWER';
export const UPDATE_CONTACT_DETAIL = 'UPDATE_CONTACT_DETAIL';
export const CREATE_NEW_CONTACT = 'CREATE_NEW_CONTACT';

//SCRUMBOARD_APP
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export const GET_SCRUM_LABEL_LIST = 'GET_SCRUM_LABEL_LIST';
export const GET_BOARDS = 'GET_BOARDS';
export const ADD_BOARD_LIST = 'ADD_BOARD_LIST';
export const ADD_LIST_CARD = 'ADD_LIST_CARD';
export const EDIT_LIST_CARD = 'EDIT_LIST_CARD';
export const DELETE_LIST_CARD = 'DELETE_LIST_CARD';
export const DELETE_BOARD = 'DELETE_BOARD';
export const ADD_NEW_BOARD = 'ADD_NEW_BOARD';
export const EDIT_BOARD_DETAIL = 'EDIT_BOARD_DETAIL';
export const EDIT_BOARD_LIST = 'EDIT_BOARD_LIST';

//CHAT_APP
export const GET_CONNECTIONS_LIST = 'get_connections_list';
export const GET_USER_MESSAGES = 'get_user_messages';
export const ADD_NEW_MESSAGE = 'add_new_message';
export const EDIT_MESSAGE = 'edit_message';
export const DELETE_MESSAGE = 'delete_message';
export const DELETE_USER_MESSAGES = 'delete_user_messages';
export const TOGGLE_CHAT_DRAWER = 'toggle_chat_drawer';
export const SELECT_USER = 'select_user';
export const ADD_CHAT_MESSAGE = 'add_chat_message';

//WALL_APP
export const GET_WALL_DATA = 'get_wall_data';
export const GET_FEED_POSTS = 'get_feed_posts';
export const CREATE_NEW_POST = 'create_new_post';
export const UPDATE_POST = 'update_post';

//USER_LIST
export const GET_USER_LIST = 'GET_USER_LIST';

//ECOMMERCE_LIST
export const GET_ECOMMERCE_LIST = 'get_ecommerce_list';
export const SET_PRODUCT_VIEW_TYPE = 'set_product_view_type';
export const SET_FILTER_DATA = 'set_filter_data';
export const SET_PRODUCT_DATA = 'set_product_data';
export const GET_RECENT_ORDER = 'get_recent_order';
export const GET_CUSTOMERS = 'get_customers';
export const ADD_CART_ITEM = 'add_cart_item';
export const REMOVE_CART_ITEM = 'remove_cart_item';
export const UPDATE_CART_ITEM = 'update_cart_item';
export const SET_CART_ITEMS = 'set_cart_items';

//CK-EDITOR
export const GET_BALLOON_BLOCK_DATA = 'get_balloon_block_data';
export const UPDATE_BALLOON_BLOCK_DATA = 'update_balloon_block_data';
export const GET_BALLOON_DATA = 'get_balloon_data';
export const UPDATE_BALLOON_DATA = 'update_balloon_data';
export const GET_CLASSIC_DATA = 'get_classic_data';
export const UPDATE_CLASSIC_DATA = 'update_classic_data';
export const GET_INLINE_DATA = 'get_inline_data';
export const UPDATE_INLINE_DATA = 'update_inline_data';
export const GET_DOCUMENT_DATA = 'get_document_data';
export const UPDATE_DOCUMENT_DATA = 'update_document_data';
export const GET_CUSTOM_DATA = 'get_custom_data';
export const UPDATE_CUSTOM_DATA = 'update_custom_data';

//GALLERY
export const GET_GALLERY_PHOTO = 'get_gallery_photo';

//PAGE KKP
export const GET_LATEST_NEWS = 'get_lates_news';
export const GET_EXT_NEWS = 'get_ext_news';

//TASK MANAGEMENT
export const GET_TAB_VALUE_HEADER = 'get_tab_value_header';
export const GET_ACTION_TASK = 'get_action_task';
export const GET_TREE_TM = 'get_tree_tm';
export const GET_DASHBOARD_COUNT_TM = 'get_dashboard_count_tm';
export const GET_MONITORING_TM = 'get_monitoring_tm';
export const GET_PROJECT_CHOICE_TM = 'get_project_choice_tm';
export const GET_LIST_TM = 'get_list_tm';
export const DELETE_LIST_TM = 'delete_list_tm';
export const GET_PROJECT_DETAIL_TM = 'get_project_detail_tm';
export const GET_TASK_DETAIL_TM = 'get_task_detail_tm';
export const ADD_CATEGORY = 'add_category';
export const PUT_CATEGORY = 'put_category';
export const DELETE_CATEGORY = 'delete_category';
export const ADD_FOLDER = 'add_folder';
export const ADD_LIST = 'add_list';
export const PUT_LIST = 'put_list';
export const DELETE_LIST = 'delete_list';
export const ADD_TASK = 'add_task';
export const PUT_TASK = 'put_task';
export const UPDATE_STATUS_TASK = 'update_task';
export const ADD_ATTACHMENT_TM = 'add_attachment_tm';
export const ADD_COMMENT_TM = 'add_comment_tm';
export const DELETE_TASK_TM = 'delete_task_tm';
export const DELETE_ATTACHMENT_TM = 'delete_attachment_tm';
export const DELETE_ALL_ATTACHMENT_TM = 'delete_all_attachment_tm';

//REPOSITORY
export const GET_DOCUMENTS = 'get_documents'
export const ADD_DOCUMENT = 'add_document'
export const ADD_DOCUMENT_ATTACHMENT = 'add_document_attachment'
export const ADD_ATTACHMENT_COMMENT = 'add_attachment_comment'
export const EDIT_DOCUMENT = 'edit_document'
export const RATE_DOCUMENT = 'rate_document'
export const UPDATE_DOCUMENT_ATTACHMNET = 'update_document_attachment'
export const ATTACHMNET_VIEW = 'attachment_view'
export const DELETE_DOCUMENT_ATTACHMENT = 'delete_document_attachment'
export const DELETE_ATTACHMENT_COMMENT = 'delete_attachment_comment'
export const DELETE_ALL_DOCUMENT_ATTACHMENT = 'delete_all_document_attachment'
export const DELETE_ALL_ATTACHMENT_COMMENT = 'delete_all_attachment_comment'
export const DELETE_DOCUMENT = 'delete_document'
export const GET_DETAIL_DOCUMENT = 'get_detail_document'
export const ADD_COMMENT = 'add_comment'
export const GET_DOC_SHARED_WITH_ME = 'get_doc_shared_with_me'
export const GET_FOLDER_PAGE = 'get_folder_page'
export const GET_FILTER_SEARCH = 'get_filter_search'
export const GET_FILTER_LIST = 'get_filter_list'
export const SET_LASTPATH = 'set_lastpath'
export const GET_UNKER_PREPARING = 'get_unker_preparing'
export const GET_SATKER_PREPARING = 'get_satker_preparing'
export const GET_DOCUMENT_COUNTER = 'get_document_counter'

//KNOWLEDGE MANAGEMENT
export const GET_KNOWLEDGE_POSTS = 'get_knowledge_posts';
export const GET_ACTIVE_USERS = 'get_active_users';
export const GET_POPOLAR_POST = 'get_popular_post';
export const UPDATE_KNOWLEDGE_POST = 'update_knowledge_post';
export const UPDATE_LIKED_POST_IN_DETAIL = 'update_liked_post_in_detail';
export const UPDATE_LIST_POST_BY_ID = 'update_list_post_by_id';
export const GET_DETAIL_POST = 'get_detail_post';
export const ADD_COMMENT_POST = 'add_comment_post';
export const GET_OTHER_POST = 'get_other_post';
export const GET_PROFILE_ID = 'get_profile_id';
export const GET_PROFILE_ARTICLE = 'get_profile_article';
export const GET_PROFILE_ACTIVITY = 'get_profile_activity';
export const POST_ADD_COMMENT = 'post_add_comment';
export const RESET_DETAIL_POST = 'reset_detail_post';
export const GET_LIST_VIEWED_POST = 'get_list_viewed_post';
export const GET_LIST_LIKED_POST = 'get_list_liked_post';
export const GET_KATEGORI = 'get_kategori';
export const GET_KOMPETENSI = 'get_kompetensi';
export const GET_UNITKERJA = 'get_unitkerja';
export const GET_SATKERBYUNKER = 'get_satkerbyunker';
export const SET_FILTERSEARCH = 'set_filtersearch';

//KNOWLEDGE MANAGEMENT MYPOST
export const GET_CHART_POINT = 'get_chart_point';
export const GET_CHART_VIEW = 'get_chart_view';
export const GET_CHART_POST = 'get_chart_post';
export const GET_CHART_LIKE = 'get_chart_like';
export const GET_CHART_COUNT = 'get_chart_count';
export const GET_MYPOST_LIST = 'get_mypost_list';
export const DELETE_MYPOST_LIST = 'delete_mypost_list';
export const POST_ARTICLE = 'post_article';
export const POST_ARTICLE_DRAFT = 'post_article_draft';
export const POST_ATTACHMENT = 'post_attachment';
export const DELETE_ATTACHMENT = 'delete_attachment';
export const DELETE_ALL_ATTACHMENT = 'delete_all_attachment';
export const GET_LIST_CATEGORY = 'get_list_category';
export const GET_LIST_COMPETENCE = 'get_list_competence';
export const UPDATE_ARTICLE = 'update_article';
export const UPDATE_ARTICLE_DRAFT = 'update_article_draft';

//KNOWLEDGE MANAGEMENT ADMN
export const GET_LIST_PENILAIAN = 'get_list_penilaian';
export const GET_REVIEW_COUNT = 'get_review_count';
export const GET_PENILAIAN_ID = 'get_penilaian_id';
export const GET_LIST_KATEGORI_ADMIN = 'get_list_kategori_admin';
export const GET_LIST_KOMPETENSI_ADMIN = 'get_list_kompetensi_admin';
export const GET_DETAIL_KATEGORI = 'get_detail_kategori';
export const GET_DETAIL_KOMPETENSI = 'get_detail_kompetensi';
export const ADD_NEW_KATEGORI = 'add_new_kategori';
export const RESET_DETAIL_KATEGORI = 'reset_detail_kategori';
export const RESET_DETAIL_KOMPETENSI = 'reset_detail_kompetensi';
export const DELETE_KATEGORI = 'delete_kategori';
export const DELETE_KOMPETENSI = 'delete_kompetensi';

// KNOWLEDGE MANAGEMENT ADMIN SUMMARY
export const GET_SUMMARY_TOTAL_POST = 'get_summary_total_post';
export const GET_SUMMARY_ACCUMULATION = 'get_summary_accumulation';
export const GET_SUMMARY_GRAPH = 'get_summary_graph';
export const GET_SUMMARY_REVIEW = 'get_summary_review';
export const GET_SUMMARY_BAD_USER = 'get_summary_bad_user';
export const KM_CHANGE_TW_YEAR = 'km_change_tw_year';

// PAGE KEBIJAKAN
export const GET_CAT_POLICY = 'get_cat_policy';
export const GET_CAT_POLICY_ID = 'get_cat_policy_id';
export const GET_UNKER = 'get_unker';
export const GET_UNKER_ID = 'get_unker_id';
export const GET_POLICY_SEARCH = 'get_policy_search';
export const GET_COUNTER_DOWNLOAD_POLICY = 'get_counter_download_policy';
export const GET_COUNTER_VIEW_POLICY = 'get_counter_view_policy';

//KLASIFIKASI ARSIP
export const GET_KLASIFIKASI_ARSIP = 'get_klasifikasi_arsip';

//TITLE TREE
export const GET_TITLE_TREE = 'get_title_tree';
export const GET_TITLE_OPTIONS = 'get_title_options';


//PEGAWAI ADDRESSBOOK
export const GET_PEGAWAI = 'get_pegawai';

//PERSONAL ADDRESSBOOK
export const GET_PERSONAL = 'get_personal';

//DIVISON LIST ADDRESSBOOK
export const GET_DIVISION = 'get_division';
export const GET_DIVISION_OPTIONS = 'get_division_options';

//PORTAL KKP
export const GET_BANNER = 'get_banner';
export const GET_NEWS = 'get_news';
export const GET_NEWS_ID = 'get_news_id';
export const GET_GALLERY = 'get_gallery';
export const GET_ANNOUNCEMENT = 'get_announcement';
export const GET_NOTIFICATIONS = 'get_notifications';
export const GET_COUNT_NOTIFICATIONS = 'get_count_notifications';
export const READ_NOTIFICATION = 'read_notification';

//ADMINTOOLS 

export const GET_DATATABLE_COLUMN = 'get_data_table_column';
export const GET_DATATABLE_ROW = 'get_data_table_row';
export const UPDATE_DATATABLE_COLUMN = 'update_data_table_column';
export const UPDATE_DATATABLE_ROW = 'update_data_table_row';
export const UPDATE_DATATABLE_TABLE_INFO = 'update_data_table_table_info';
export const GET_ROLE_LIST = "get_role"
export const GET_ROLE_LIST_ALL = "get_role_list_all"
export const GET_FAQ_DETAIL_ADMINTOOLS = "get_faq_detail"
export const GET_FAQ_DETAIL_CATEGORY_ADMINTOOLS = "get_faq_detail_category"
export const GET_FAQ_DETAIL_GROUP_ADMINTOOLS = "get_faq_detail_group"

export const GET_FAQ_CATEGORIES_OPTION_ADMINTOOLS = "get_faq_categories_option"
export const GET_FAQ_GROUPS_OPTION_ADMINTOOLS = "get_faq_groups_option"
export const GET_FAQ_CATEGORIES_ADMINTOOLS = "get_faq_categories"

export const GET_FAQ_GROUPS_ADMINTOOLS = "get_faq_groups"

export const GET_DIVISION_DETAIL_ADMINTOOLS = 'get_division_detail_admintools';
export const RESET_DIVISION_DETAIL_ADMINTOOLS = 'reset_division_detail_admintools';
export const RESET_FAQ_DETAIL_ADMINTOOLS = 'reset_faq_detail_admintools';
export const GET_DEPARTMENT_DETAIL_ADMINTOOLS = 'get_department_detail_admintools';
export const GET_DEPARTMENT_OPTIONS = 'get_department_options';

export const RESET_DEPARTMENT_DETAIL_ADMINTOOLS = 'reset_department_detail_admintools';
export const GET_KM_DETAIL_ADMINTOOLS = 'get_km_detail_admintools';
export const RESET_KM_DETAIL_ADMINTOOLS = 'reset_km_detail_admintools';
export const GET_NOTATINDAKAN_DETAIL_ADMINTOOLS = 'get_km_detail_admintools';
export const RESET_NOTATINDAKAN_DETAIL_ADMINTOOLS = 'reset_km_detail_admintools';
export const GET_JOBS_OPTION_ADMINTOOLS = 'get_jobs_options_admintools';
export const GET_JOBS_DETAIL_ADMINTOOLS = 'get_jobs_detail_admintools';

export const RESET_JOBS_DETAIL_ADMINTOOLS = 'reset_job_detail_admintools';
export const RESET_DATA_TABLE = "reset_datatable_admintools";

export const DIV_LIST = 'div_list';
export const DIV_DEPT_LIST = 'div_dept_list';
export const DIV_DEPT_LEADER_LIST = 'div_dept_leader_list';


export const RESET_PROFILE_ADMINTOOLS = "reset_profile_admintools"
export const GET_ADMINTOOLS_PAGE = 'get_admintools_page';
export const GET_PEGAWAI_ADMINTOOLS = 'get_pegawai_admintools';
export const GET_PROFILE_ADMINTOOLS = 'get_profile_admintools';
export const POST_PROFILE_ADMINTOOLS = 'post_profile';
export const GET_PROFILE_DETAIL_ADMINTOOLS = 'get_profile_detail_admintools';
export const GET_TITLE_DETAIL_ADMINTOOLS = 'get_title_detail_admintools';
export const GET_TITLE_ADMINTOOLS = 'get_title_admintools';
export const POST_TITLE_ADMINTOOLS = 'post_title_admintools';
export const RESET_TITLE_ADMINTOOLS = 'reset_title'
export const UPDATE_LAST_PAGE_DATATABLE = 'update_last_page_datatable'
export const UPDATE_LAST_SEARCH_DATATABLE = 'update_last_search_datatable'

export const UPDATE_LAST_TYPE_DATATABLE = 'update_last_type_datatable';
export const GET_LIST_PENOMORAN = 'get_list_penomoran';
export const GET_LIST_SCAN_SURAT = 'get_list_scan_surat';

export const SET_FILTER_LIST_PENOMORAN = 'set_filter_list_penomoran';

// DIGITAL SIGN
export const GET_LIST_COMPOSER = 'get_list_composer';
export const GET_LIST_REVISION = 'get_list_revision';
export const GET_LIST_NUMBER = 'get_list_number';
export const GET_LIST_INPROGRESS = 'get_list_inprogress';
export const GET_OPTION_PYB = 'get_option_pyb'
export const GET_OPTION_PYB_PPID = 'get_option_pyb_ppid'
export const GET_OPTION_PYB_PK = 'get_option_pyb_pk'
export const GET_LIST_READY = 'get_list_ready';
export const GET_LIST_COMPLETED = 'get_list_completed'
export const GET_LIST_DRAFT = 'get_list_draft'
export const GET_LIST_INBOX_PK = 'get_list_inbox_pk'
export const GET_LIST_APPROVAL_SK = 'get_list_approval_sk'
export const GET_LIST_NEEDSIGN_SK = 'get_list_need_sign_sk'
export const GET_DASHBOARD_SK = 'get_dashboard_sk'

export const ADD_DOCUMENT_DIGISIGN = 'add_document_digisign'
export const REJECT_DOCUMENT_DIGISIGN = 'reject_document_digisign'
export const ADD_ATTACHMENT_DIGISIGN = 'add_attachment_digisign'
export const DELETE_ATTACHMENT_DIGISIGN = 'delete_attachment_digisign'
export const RESET_DIGISIGN = 'reset_digisign'
export const GET_DETAIL_DIGISIGN = 'get_detail_digisign'
export const UPDATE_DOCUMENT_DIGISIGN = 'update_document_digisign'
export const UPDATE_INPROGRESS_DIGISIGN = 'update_inprogress_digisign'
export const ONCHANGE_STATE_FILTER = 'onchange_state_filter'
export const GET_LIST_COURSE_DIGISIGN = 'get_list_course_digisign'
export const GET_DETAIL_COURSE_DIGISIGN = 'get_detail_course_digisign'
export const DELETE_DETAIL_COURSE_DIGISIGN = 'delete_detail_course_digisign'
export const GET_REJECTED_DIGISIGN = 'get_rejected_digisign'
export const GET_REVISI_DIGISIGN = 'get_revisi_digisign'
export const GET_SIGNED_DIGISIGN = 'get_signed_digisign'
export const GET_RETRY_DIGISIGN = 'get_signed_digisign'
export const GET_SUMMARY_COUNT = 'get_summary_count'
export const GET_SUMMARY_LIST = 'get_summary_list'
export const GET_SUBJECT_LIST = 'get_subject_list'
export const GET_TEMPLATE_DIGISIGN = 'get_template_digisign'
export const GET_PENERIMA_SERTIF_DIGISIGN = 'get_penerima_sertif_digisign'
export const GET_SERTIFIKAT_EXTERNAL = 'get_sertifikat_external'
export const GET_DETAIL_SERTIFIKAT_EXTERNAL = 'get_detail_sertifikat_external'
export const GET_PERIZINAN_ESEA_COUNT = 'get_perizinan_esea_count'
export const GET_PENOMORAN_PERIZINAN = 'get_penomoran_perizinan'
export const DELETE_PENOMORAN_PERIZINAN = 'delete_penomoran_perizinan'
export const GET_TRACK_DIGISIGN = 'get_track_digisign'
export const GET_PERIZINAN_PKRL_COUNT = 'get_perizinan_pkrl_count'
export const GET_PERIZINAN_PKRL_DASHBOARD = 'get_perizinan_pkrl_dashboard'
export const GET_MONITORING_DASHBOARD = 'get_monitoring_dashboard'
export const GET_DASHBOARD_COUNT_DOKUMEN = 'get_dashboard_count_dokumen'
export const GET_DIGISIGN_COUNT = 'get_digisign_count'
export const GET_SIAPMUTU_COUNT = 'get_siapmutu_count'
export const GET_TEMPLATE_RECEIVERS_BANKOM = 'get_template_receivers_bankom'



// PRODUK LPMUKP
export const GET_LIST_DOKUMEN_LPMUKP = 'get_list_dokumen_lpmukp';
export const GET_DETAIl_DOKUMEN_LPMUKP = 'get_detail_dokumen_lpmukp';
export const CHANGE_FILTER_PLPMUKP = 'change_filter_plpmukp';

//SERTIFIKAT MENTERI
export const ADD_CSV_TO_JSON_DIGISIGN = 'add_csv_to_json_digisign'
export const RESET_LIST_RECEIVERS_DIGISIGN = 'reset_list_receivers_digisign'

//SATKER 
export const GET_BANNER_SATKER = 'get_banner_satker';
export const GET_GALLERY_SATKER = 'get_gallery_satker';
export const GET_PESAN_SATKER = 'get_pesan_satker';
export const GET_BIRTHDAY_SATKER = 'get_birthday_satker';
export const GET_NEWS_SATKER = 'get_news_satker';
export const GET_NEWS_SATKER_ID = 'get_news_satker_id';

//PROFILE
export const GET_PROFILE_LIST = 'get_profile_list';
export const GET_PROFILE_DETAIL = 'get_profile_detail';
export const GET_PROFILE_DETAIL_PEGAWAI = 'get_profile_detail_pegawai';
export const PUT_PROFILE_ME = 'put_profile_me';

// CHAT
export const GET_ROOMS = 'get_rooms';
export const GET_CHAT = 'get_chat';
export const CREATE_ROOM = 'create_room';
export const CREATE_CHAT = 'create_chat';
export const SELECT_ROOM = 'select_room';
export const STORE_MQTT_CLIENT = 'store_mqtt_client';

// ROLE
export const CREATE_ROLE = 'create_role';
export const ADD_MEMBER_ROLE = 'add_member_role';
export const DELETE_MEMBER_ROLE = 'delete_member_role';
export const LIST_ROLE = 'list_role';
export const DETAIL_ROLE = 'detail_role';
export const UPDATE_ROLE = 'update_role';
export const DELETE_ROLE = 'delete_role';
export const IMPORT_ROLE = 'import_role';
export const EXPORT_ROLE = 'export_role';
export const PAGE_LIST_ROLE = 'page_list_role';
export const DELETE_MULTIPLE_ROLE = 'delete_multiple_role';
export const GET_LIST_SERVICE_ROLE = 'get_list_service_role';

// EVENT MANAGEMENT
export const EVENT_CREATE = 'event_create';
export const EVENT_LIST = 'event_list';
export const EVENT_TODAY_LIST = 'event_today_list';
export const EVENT_ID = 'event_id';
export const EVENT_UPDATE = 'event_update';
export const EVENT_UPDATE_STATUS = 'event_update_status';
export const EVENT_DELETE = 'event_delete';
export const AGENDA_CREATE = 'agenda_create';
export const AGENDA_LIST = 'agenda_list';
export const AGENDA_ID = 'agenda_id';
export const AGENDA_UPDATE = 'agenda_update';
export const AGENDA_DELETE = 'agenda_delete';
export const NOTULENSI_CREATE = 'notulensi_create';
export const NOTULENSI_LIST = 'notulensi_list';
export const NOTULENSI_ID = 'notulensi_id';
export const NOTULENSI_UPDATE = 'notulensi_update';
export const NOTULENSI_DELETE = 'notulensi_delete';
export const PRESENSI_LIST = 'presensi_list';
export const PRESENSI_ID = 'presensi_id';
export const PRESENSI_UPDATE = 'presensi_update';
export const PRESENSI_DELETE = 'presensi_delete';
export const ATTACHMENT_CREATE = 'attachment_create';
export const ATTACHMENT_DELETE = 'attachment_delete';
export const ATTACHMENT_DELETE_ALL = 'attachment_delete_all';
export const TASK_CREATE = 'task_create';
export const TASK_LIST = 'task_list';
export const TASK_ID = 'task_id';
export const TASK_UPDATE = 'task_update';
export const TASK_DELETE = 'task_delete';
export const APPROVER_LIST = 'approver_list';
export const EVENT_LIST_PROGRESS = 'event_list_progress';
export const NOTULENSI_APPROVE = 'notulensi_approve';
export const NOTULENSI_READY_TO_APPROVE = 'notulensi_ready_to_approve';
export const COMMENT_ADD_EM = 'comment_add_em';
export const AGENDA_UPDATE_STATE = 'agenda_update_state';
export const EVENT_CHOISE_CALENDAR = 'event_choise_calendar';
export const EVENT_NOTIFICATION = 'event_notification';
export const AGENDA_NOTIFICATION = 'agenda_notification';
export const PAGE_EVENT_LIST = 'page_event_list';
export const NOTULENSI_ID_SETNULL = 'notulensi_id_setNull';
export const SPESIMEN_ID = 'spesimen_id';

// KALENDER
export const GET_LIST_GRUP_KALENDER = 'get_list_grup_kalender';
export const GET_LIST_ACARA = 'get_list_acara';
export const GET_LIST_ACARA_EVENT = 'get_list_acara_event';
export const GET_PIC_ACARA = 'get_pic_acara';
export const GET_DETAIL_ACARA = 'get_detail_acara';
export const GET_DETAIL_GRUP = 'get_detail_grup';
export const UPDATE_GRUP_KALENDER = 'update_grup_kalender';
export const UPDATE_EVENT_KALENDER = 'update_event_kalender';
export const CREATE_GRUP_KALENDER = 'create_grup_kalender';
export const CREATE_ACARA = 'create_acara';
export const GET_ID_GRUP = 'get_id_grup';
export const DELETE_ID_GRUP = 'delete_id_grup';
export const DELETE_ACARA_KALENDER = 'delete_acara_kalender';
export const DELETE_PIC = 'delete-pic';
export const GET_STATE = 'get_state';
export const GET_LIST_SUBAGENDA = 'get_list_subagenda';
export const RESET_LIST_ACARA_PERSONAL = 'reset_list_acara_perconal';
export const GET_LIST_ACARA_PERSONAL = 'get_list_acara_personal';
export const GET_DETAIL_ACARA_PERSONAL = 'get_detail_acara_personal';
export const GET_LIST_ACARA_SATKER = 'get_list_acara_satker';
export const GET_DETAIL_ACARA_SATKER = 'get_detail_acara_satker';

// APP MODE
export const SET_MODE = 'set_mode';

//SIDEBAR SETTINGS
export const SAVE_SETTINGS = 'save_settings';

// SEQUENCE
export const GET_OWN = 'GET_OWN';
export const SEQUENCE_UPDATE = 'SEQUENCE_UPDATE';

//SURVEY
export const ADD_SURVEY = 'add_survey'
export const GET_SURVEY_REPORT = 'get_survey_report'
export const GET_SURVEY_COUNT = 'get_survey_count'
export const GET_SURVEY_DETAIL = 'get_survey_detail'

// PRESENSI
export const GET_LIST_PRESENSI = 'get_list_presensi'
export const GET_LAST_LOG = 'get_last_log'

// GROUP ADDRESSBOOK
export const GET_LIST_GROUP_ADDR = 'get_list_group_addr'
export const POST_EDIT_GROUP_ADDR = 'post_edit_group_addr'
export const POST_ADD_GROUP_ADDR = 'post_add_group_addr'
export const GET_DETAIL_GROUP_ADDR = 'get_detail_group_addr'

// KEPEGAWAIAN
export const GET_UNKER_PEGAWAI = 'get_unker_pegawai'
export const GET_SATKER_BY_UNKER = 'get_satker_by_unker'
export const GET_UNKER_CHOICE = 'get_unker_choice'
export const GET_RESULT_PEGAWAI = 'get_result_pegawai'
export const DELETE_UNKER_CHOICE = 'delete_unker_choice'
export const DELETE_RESULT_PEGAWAI = 'delete_result_pegawai'
export const GET_LIST_KEPEGAWAIAN_PEGAWAI_IPASN = 'get_list_kepegawaian_pegawai_ipasn'
export const GET_LIST_KEPEGAWAIAN_PEGAWAI_PRIBADI = 'get_list_kepegawaian_pegawai_pribadi'
export const GET_DETAIL_KEPEGAWAIAN_PEGAWAI = 'get_detail_kepegawaian_pegawai'
export const CHANGE_TAB_KEPEGAWAIAN_IPASN = 'change_tab_kepegawaian_ipasn'

// FILE REPORT
export const GET_LIST_FILE_REPORT = 'get_list_file_report'
export const CREATE_FILE_REPORT = 'create_file_report'
export const DELETE_FILE_REPORT = 'delete_file_report'
export const DOWNLOAD_FILE_REPORT = 'download_file_report'

// KOP SURAT
export const GET_KOP_SURAT = 'get_kop_surat'
export const UPDATE_KOP_SURAT = 'update_kop_surat'

// Produk Hukukm
export const GET_PH_LIST = 'get_ph_list'
export const GET_PH_ID = 'get_ph_id'
export const GET_PH_COUNT = 'get_ph_count'
export const GET_NUMBER_PH = 'get_number_ph'
export const GET_NUMBER_PH_DIRJEN = 'get_number_ph_dirjen'
export const ADD_ATTACHMENT_DIGISIGN_PH = 'add_attachment_digisign_ph'
export const DELETE_ATTACHMENT_DIGISIGN_PH = 'delete_attachment_digisign_ph'
export const UPDATE_ATTACHMENT_DIGISIGN_PH = 'update_attachment_digisign_ph'
export const GET_NUMBER_OPERATOR_PH = 'get_number_operator_ph'
export const DELETE_DATA_NOMOR = 'delete_data_nomor'
export const DELETE_DATA_DETAIL = 'delete_data_detail'
export const GET_NEW_NUMBER_PH = 'get_new_number_ph'
export const GET_LIST_NUMBER_PH = 'get_list_number_ph'
export const GET_LIST_NUMBER_PH_BY_USER = 'get_list_number_ph_by_user'
export const GET_DETAIL_NUMBER_PH = 'get_detail_number_ph'

// NOTULENSI
export const GET_LIST_NOTULENSI = 'get_list_notulensi'
export const GET_SHARED_NOTULENSI = 'get_shared_notulensi'
export const GET_DETAIL_DOC_NOTULENSI = 'get_detail_doc_notulensi'
export const DELETE_DOC_NOTULENSI = 'delete_doc_notulensi'

// PROGRAM KERJA
export const GET_LIST_PROGRAM_KERJA = 'get_list_program_kerja';
export const RESET_DATA_PROGRAM_KERJA = 'reset_data_program_kerja';
export const GET_DASHBOARD_PROGRAM_KERJA = 'get_dashboard_program_kerja';
export const ADD_ATTACHMENT_PROGRAM_KERJA = 'add_attachment_program_kerja';
export const SET_ATTACHMENT_PROGRAM_KERJA = 'set_attachment_program_kerja';
export const RESET_KOMENTAR_PROGRAM_KERJA = 'reset_komentar_program_kerja';
export const DELETE_ATTACHMENT_PROGRAM_KERJA = 'delete_attachment_program_kerja';
export const GET_CREATE_KOMENTAR_PROGRAM_KERJA = 'get_create_komentar_program_kerja';
// PROGRAM KERJA OPTION
export const GET_ESELON_LIST = 'get_eselon_list';
export const GET_OPTION_PROGRAM_KERJA = 'get_option_program_kerja';
export const GET_OPTION_STATUS_PROGRAM_KERJA = 'get_option_status_program_kerja';
export const GET_OPTION_INTERVENSI_PROGRAM_KERJA = 'get_option_intervensi_program_kerja';

// NOTIFICATION PREFERENCE
export const GET_LIST_APP_NOTIFICATION = 'get_list_app_notification';
export const UPDATE_STATE_APP_NOTIFICATION = 'update_state_app_notification';
export const GET_BLAKLIST_APP_NOTIFICATION = 'get_blacklist_app_notification';

// BPK DRIVE
export const GET_COUNTER_BPK = 'get_counter_bpk'
export const GET_LIST_PERMINDOK = 'get_list_permindok'
export const GET_LIST_PERMINDOK_MONITORING = 'get_list_permindok_monitoring'
export const GET_DETAIL_PERMINDOK = 'get_detail_permindok'
export const GET_SUB_DETAIL_PERMINDOK= 'get_sub_detail_permindok'
export const GET_DETAIL_PERMINDOK_MONITORING = 'get_detail_permindok_monitoring'
export const ADD_PERMINDOK = 'add_permindok'
export const ADD_FOLDER_KKP = 'add_folder_kkp'
export const DELETE_FOLDER_KKP = 'delete_folder_kkp'
export const DELETE_FILE_KKP = 'delete_file_kkp'
export const PATCH_READ_FILE = 'patch_read_file'
export const DOWNLOAD_ALL_FOLDER = 'download_all_folder'
export const DELETE_PERMINDOK = 'delete_permindok'

export const ADD_PERMINDOK_ATTACHMENT = 'add_permindok_attachment'
export const ADD_FILE_KKP = 'add_file_kkp'
export const EDIT_PERMINDOK = 'edit_permindok'
export const DELETE_PERMINDOK_ATTACHMENT = 'delete_permindok_attachment'
export const DELETE_ALL_PERMINDOK_ATTACHMENT = 'delete_all_permindok_attachment'

export const GET_LIST_KONSEP_TEMUAN = 'get_list_konsep_temuan'
export const GET_LIST_KONSEP_TEMUAN_MONITORING = 'get_list_konsep_temuan_monitoring'
export const GET_DETAIL_KONSEP_TEMUAN = 'get_detail_konsep_temuan'
export const ADD_KONSEP_TEMUAN = 'add_konsep_temuan'
export const ADD_KONSEP_TEMUAN_ATTACHMENT = 'add_konsep_temuan_attachment'
export const DELETE_KONSEP_TEMUAN_ATTACHMENT = 'delete_konsep_temuan_attachment'
export const DELETE_ALL_KONSEP_TEMUAN_ATTACHMENT = 'delete_all_konsep_temuan_attachment'

export const GET_LIST_KONSEP_TEMUAN_KKP = 'get_list_konsep_temuan_kkp'

export const GET_LIST_OPTION_BPK = 'get_list_option_bpk'
export const GET_OPTION_UNKER_PERMINDOK = 'get_option_unker_permindok'

export const DISPOSITION_PERMINDOK = 'disposition_permindok'